import { IconButton } from 'material-ui';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import AddIcon from 'material-ui/svg-icons/content/add';
import EditIcon from 'material-ui/svg-icons/image/edit';
import * as React from 'react';
import { Views } from '..';

interface IStandartTableViewTopBarProps {
    onAdd?: () => void
    onEdit?: () => void
    onDelete?: () => void
    onSearch: (sText: string) => void
    deleteDisabled?: boolean
    editDisabled?: boolean
}

export default class StandartTableViewTopBar<P, S> extends React.Component<P & IStandartTableViewTopBarProps, S> {

    public render(): JSX.Element {
        const { onAdd, onDelete, onEdit, onSearch, deleteDisabled, editDisabled } = this.props;
        const noActions = !onAdd && !onEdit && !onDelete
        return (
            <div className="top-bar">
                <div style={{width:noActions?'100%':'calc(100% - 200px)'}} className="side left">
                    <Views.TextField
                        floatingLabelText="Поиск"
                        fullWidth={true}
                        name="search"
                        onChange={(e: React.FormEvent<any>) => onSearch(e.target['value'])}
                    />
                </div>
                <div style={{display:noActions?'none':'inline-flex'}} className="side right">
                    {onAdd ?
                        <IconButton onClick={onAdd}>
                            <AddIcon />
                        </IconButton> : null}
                    {onEdit ?
                        <IconButton 
                            disabled={editDisabled}
                            onClick={onEdit}>
                            <EditIcon />
                        </IconButton> : null}
                    {onDelete ?
                    <IconButton
                        disabled={deleteDisabled}
                        onClick= { onDelete } 
                    >
                        <DeleteIcon />
                    </IconButton>:null}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/abstract/Views/StandartTableViewTopBar.tsx